import { get } from 'lodash';
import ajax from './ajax';
import cache from './cache';
import OSS from 'ali-oss';
import UserList from '../page/userManage/userList/userList.vue';
import { update } from 'lodash';

const api = {
  //公共模块
  public: {
    config: {
      accessKeyId: '',
      accessKeySecret: '',
      stsToken: '',
      expiration: '',
      endpoint: '',
      bucket: '',
    },

    oss: {
      getImgPath(url) {
        return `https://${api.public.config.bucket}.${api.public.config.endpoint}/${url}`;
      },

      path: {
        // 商品图片
        goodsImg: 'common/images/product/',
        // 商品视频
        goodsVideo: 'common/video/product/',
        // 广告
        adv: 'common/images/mwebrcd/',
        //notice
        notice: 'common/images/notice/',
        // 页游
        webGame: 'common/images/game/web/',
        //租号
        rent: 'rent/',
        //充值
        recharge: 'common/images/recharge/',
        //游戏人生
        yxrs: 'yxrs/'
      },
      onceClient(param) {
        api.public.oss.getOssConfig(data => {
          new OSS.Wrapper({
            accessKeyId: data.accessKeyId,
            accessKeySecret: data.accessKeySecret,
            stsToken: data.stsToken,
            expiration: data.expiration,
            bucket: data.bucket,
            endpoint: data.endpoint
          }).multipartUpload(api.public.oss.getPath(param.type, param.suffix), param.file, {
            parallel: 2,
            progress: function* (percent, cpt) {
              typeof param.progress === 'function' && param.progress(percent, cpt);
            }
          }).then(function (result) {
            typeof param.success === 'function' && param.success(result);
          }).catch(function (err) {
            typeof param.error === 'function' && param.error(err);
          });
        });
      },
      getPath(type = "goodsImg", suffix = 'jpg') {
        return api.public.oss.path[type] + new Date().getTime() + Math.random().toString(36).substr(2) + '.' + suffix;
      },
      getOssConfig(fn) {
        if (!api.public.config.accessKeyId) {
          const ossConfig = cache.fetchOssConfig();
          if (ossConfig && ossConfig.accessKeyId) {
            fn({...ossConfig})
          } else {
            api.public.oss.initOssConfig(fn);
          }
        } else {
          fn({...api.public.config})
        }
      },

      initOssConfig(fn) {
        ajax.fetch({
          url: 'oss/getOssConfig',
          disableLoading: false,
          method: 'get',
          successFunc: response => {
            api.public.config.accessKeyId = response.access_key_id;
            api.public.config.accessKeySecret = response.access_key_secret;
            api.public.config.stsToken = response.security_token;
            api.public.config.expiration = response.expiration;
            api.public.config.endpoint = response.endPoint;
            api.public.config.bucket = response.bucket;
            cache.storeOssConfig(response);
            typeof fn === 'function' && fn({...api.public.config});
          },
          errorFunc: error => {
            alert('获取oss配置失败，请刷新浏览器，若不使用上传文件功能可忽略');
          }
        })
      },
    },

    //登录地址
    login: 'admin/loginAuth',

    //登出地址
    loginOut: 'admin/loginOut',
  },
  goodsManage:{
    getProductType: 'product/getProductType',
    get: 'product/getProducts',
    delete: 'product/deleteProduct',
    getProductDetail: 'product/getProductDetail',
    update: 'product/updateProduct',
    add: 'product/addProduct'
  },
  gamesManage:{
    get: 'game/getGames',
    add: 'game/addGame',
    update: 'game/updateGame',
    updateGameStatus: 'game/updateGameStatus',
  },
  lotteryActivity:{
    get: 'activity/getLotteryActivities',
    add: 'activity/addLotteryActivity',
    update: 'activity/updateLotteryActivity',
    updateActivityRemark: 'activity/updateActivityRemark',
  },
  taskRecords:{
    get: 'task/getTaskRecords',
    getOutGameSelected: 'game/getOutGameSelected',
    getTaskRecordDetail: 'task/getTaskRecordDetail',
    updateTaskOrder: 'task/updateTaskOrder',
  },
  userList:{
    get: 'user/getUserList',
    getUserBarPoint: 'user/getUserBarPoint'
  },
  integralDetails:{
    get: 'user/getUserPointDetail'
  },
  advertisingManage:{
    get: 'adv/list',
    add: 'adv/add',
    update: 'adv/edit'
  },
  pointsLotteryPage:{
    get: 'lotteryActivityTab/getList',
    add: 'lotteryActivityTab/add',
    update: 'lotteryActivityTab/update'
  },
  packetRecord:{
    get: 'userPacketRecord/list'
  },
  netBarAccountManage:{
    get: 'netBarAccount/list',
    add: 'netBarAccount/insert',
    update: 'netBarAccount/edit',
    import: 'netBarAccount/import',
    downLoad: 'activityPrize/getTemplateName'
  },
  lotteryActivityTaskPrizes:{
    get: 'activity/getLotteryPrizes',
    updateStatus: 'activity/updatePrizeStatus',
    add: 'activity/setLotteryPrizes',
    updateOrder: 'activity/updatePrizeOrder',
    updateProbability: 'activity/updatePrizeProb',
    updateUsedStock: 'activity/updatePrizeExtractNum',
    getSyncStockCdKeyList: 'activityPrize/getSyncStockCdKeyList',
    extractCdKey: 'activityPrize/extractCdKey',
    import: 'activityPrize/syncStockCdKey',
    stockWarn: 'activityPrize/stockWarn'
  },
  gameTaskPrizes:{
    get: 'taskActivityPrize/getTaskActivityPrizeList',
    add: 'taskActivityPrize/addTaskActivityPrize',
    update: 'taskActivityPrize/editTaskActivityPrize',
    getSyncStockCdKeyList: 'taskActivityPrize/getSyncStockCdKeyList',
    extractCdKey: 'taskActivityPrize/extractCdKey',
    import: 'taskActivityPrize/syncStockCdKey'
  },
  pointsStore:{
    get: 'pointExchangePrize/getPointExchangePrizeList',
    add: 'pointExchangePrize/addPointExchangePrize',
    update: 'pointExchangePrize/editPointExchangePrize',
    getSyncStockCdKeyList: 'pointExchangePrize/getSyncPointExchangePrizeList',
    extractCdKey: 'pointExchangePrize/extractPointExchangePrize',
    import: 'pointExchangePrize/syncPointExchangePrize'
  }
};
export default api;



// WEBPACK FOOTER //
// ./src/utility/api.js